import axios from 'axios';
import config from './config';

const API_URL = `${config.API_BASE_URL}/RestaurantInfo`;

export const fetchRestaurantInfo = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching restaurant info:', error);
    throw error;
  }
};

export const updateRestaurantInfo = async (data) => {
  try {
    const response = await axios.post(API_URL, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating restaurant info:', error);
    throw error;
  }
};

export const fetchSliderImages = async () => {
  try {
    const response = await axios.get(`${API_URL}/slider`);
    return response.data;
  } catch (error) {
    console.error('Error fetching slider images:', error);
    throw error;
  }
};

export const addSliderImage = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/slider`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding slider image:', error);
    throw error;
  }
};

export const updateSliderImage = async (id, formData) => {
  try {
    const response = await axios.put(`${API_URL}/slider/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating slider image:', error);
    throw error;
  }
};

export const deleteSliderImage = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/slider/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting slider image:', error);
    throw error;
  }
};

export const fetchMainPages = async () => {
  try {
    const response = await axios.get(`${config.API_BASE_URL}/main-pages`);
    return response.data;
  } catch (error) {
    console.error('Error fetching main pages:', error);
    throw error;
  }
};
